// DS6.7
import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import c from 'classnames';
import PlainButtonOrLink from '../../Buttons/PlainButtonOrLink';
import s from './Tag.scss';
/**
 * A tag for use with our `<InputField />` and related components.
 *
 * This will render a `<span>` or `<PlainButtonOrLink />` depending on if `onClick` is passed.
 */ const Tag = (_param)=>{
    var { children , size , postfix , className , href , isSelected , disabled , isTruncated , onClick  } = _param, rest = _object_without_properties(_param, [
        "children",
        "size",
        "postfix",
        "className",
        "href",
        "isSelected",
        "disabled",
        "isTruncated",
        "onClick"
    ]);
    const ElementTag = onClick || href ? PlainButtonOrLink : 'span';
    return /*#__PURE__*/ React.createElement(ElementTag, _extends({
        className: c(s['root'], disabled && s['disabled'], s[size], isSelected && s['selected'], isTruncated && s['truncated'], className),
        href: href,
        onClick: onClick
    }, rest), isTruncated ? /*#__PURE__*/ React.createElement("span", {
        className: s['truncated-contents']
    }, children) : children, postfix && /*#__PURE__*/ React.createElement("span", {
        className: s['postfix']
    }, postfix));
};
Tag.displayName = 'Tag';
export default Tag;
